import { render, staticRenderFns } from "./MeetingCaseCard.vue?vue&type=template&id=14791dde&scoped=true&"
import script from "./MeetingCaseCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MeetingCaseCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MeetingCaseCard.vue?vue&type=style&index=0&id=14791dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14791dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14791dde')) {
      api.createRecord('14791dde', component.options)
    } else {
      api.reload('14791dde', component.options)
    }
    module.hot.accept("./MeetingCaseCard.vue?vue&type=template&id=14791dde&scoped=true&", function () {
      api.rerender('14791dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/ethical-commission/meetings/components/MainContent/components/MeetingCard/MeetingCaseCard.vue"
export default component.exports